export enum PerformanceAssessmentEntryObservationStatus {
  NotObserved = 'NotObserved',
  PartiallyObserved = 'PartiallyObserved',
  FullyObserved = 'FullyObserved',
}
